
import UserRepositoryAPI from "@/modules/user/user-repository-api";
import { defineComponent, ref, inject } from "vue";
import { useI18n } from "vue-i18n";
export default defineComponent({
  props: {
    data: {
      type: Object,
      default: null,
    },
  },
  setup(props) {
    const { t } = useI18n();
    const userData = ref(props.data);
    const keycloakAuth = inject("keycloak") as Keycloak.KeycloakInstance;

    const { isAdminView } = UserRepositoryAPI();
    const isAdmin = isAdminView();
    const toast: any = inject("toast");
    const colWidth = 170;

    const onLogoutAction = () => {
      toast.add({
        severity: "info",
        summary: "Odjava uporabnika",
        detail: "",
        life: 3000,
      });
      keycloakAuth.logout({ redirectUri: window.origin });
    };
    return {
      t,
      userData,
      colWidth,
      onLogoutAction,
      isAdmin,
    };
  },
});
